/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject, Injector } from '@angular/core';
import { NavigationComponent } from '@src/app/shared/navigation/navigation.component';
import { MyInjector } from '@src/app/app.module';
import { MatIconRegistry } from '@angular/material/icon';
import { ActivatedRoute, ActivationStart, NavigationStart, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LeadProfileService } from '@src/app/modules/public/lead-profile.service';
import { MatDialog } from '@angular/material/dialog';
import { TenantService } from '@src/app/shared/tenant.service';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';
import { TenantInactivityService } from '@src/app/shared/tenant-inactivity.service';

export function toggleOff() {
    return window.location.hostname.indexOf('localhost') >= 0;
}
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NavigationComponent]
})
export class AppComponent {
  title = 'ouromc';
  injector = inject(Injector);
  iconRegistry = inject(MatIconRegistry);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute)
  http = inject(HttpClient);
  dialog = inject(MatDialog);
  cds = inject(ConfirmDialogService);
  inactiveSvc = inject(TenantInactivityService);
  tenantSvc = inject(TenantService);
  //currentUser: User;

  static readonly appName = $localize`OurOMC`;
  static isLocal = window.location.hostname === 'localhost'

  constructor() {
    MyInjector.instance = this.injector;
    this.iconRegistry.setDefaultFontSetClass('material-symbols-outlined');

    this.router.events.subscribe( e => {
        if (e instanceof NavigationStart) {
            // Close any open dialogs on navigation
            this.dialog.closeAll();
        } else if (e instanceof ActivationStart) {
            let campaignId;
            // It seems it can apprear in either...
            if (e.snapshot.paramMap.has('_campaignId')) {
                campaignId = e.snapshot.params._campaignId;
            }
            if (e.snapshot.queryParamMap.has('_campaignId')) {
                campaignId = e.snapshot.queryParams._campaignId;
            }

            if ( campaignId ) {
                const r = e.snapshot;
                const np = Object.assign({}, e.snapshot.queryParams);
                delete np._campaignId;
                this.sendMessage(campaignId);
                const lps = MyInjector.instance.get(LeadProfileService);
                lps.markAccessValidated();
                this.router.navigate([r.routeConfig.path], {queryParams: np});
            }
            //subsy.unsubscribe(); // Keep the subscription in case we need to close dialogs later
        }
    })
    this.inactiveSvc.onTimeout.subscribe( (dt) => {
        const tenantId = this.tenantSvc.getCurrentTenantId();
        const title = $localize `${tenantId} inactive`;
        const formatted = new Intl.DateTimeFormat('en-US', {
            weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        }).format(dt);
        const msg = $localize `This page is inactive since ${formatted} in ${tenantId}`;
        if (tenantId) {
            this.cds.alert(title, msg, () => {
                this.inactiveSvc.acknowledgeTimeout();
            });
        }
    })
  }
    sendMessage(campaignId: string) {
        const url = TenantService.ajaxPath + 'informus';

        const page = window.location.href;
        const message = `<p>Go on, they are interested in ${campaignId} chase them down and make them buy</p>
                        <p>They are currently on ${page}</p>
        `
        const data = {
            message,
            subject: `Good News - Someone clicked on campaign ${campaignId}`,
            sendTo: `sales`
        }

        this.http.post(url, data).subscribe(() => {
            console.log('wow!');
        }, () => {
            console.log('surprise!')
        })
    }

}
